<template>
  <div class="admin-left-sidebar pt-3 bg-white-custom" :class="isDarkMode ? 'dark' : ''">
    <b-nav pills vertical class="admin-left-sidebar--nav">
      <b-nav-item
        to="/admin"
        class="admin-left-sidebar--nav-item px-4"
        :class="{ 'active': $route.name === 'Admin Dashboard' }"
        :style="{ 'font-weight': 500 }"
      >
        <feather type="bar-chart" />
        Admin Dashboard
      </b-nav-item>
      <b-nav-item class="admin-left-sidebar--nav-item category-item px-4">
        Agency Data
      </b-nav-item>
      <b-nav-item
        v-if="$permission('list:agencies')"
        to="/admin/agencies"
        class="admin-left-sidebar--nav-item pl-5"
      >
        <b-icon-building />
        <span>Agencies</span>
      </b-nav-item>
      <b-nav-item
        v-if="$permission('list:conversations')"
        to="/admin/conversations"
        class="admin-left-sidebar--nav-item pl-5"
        :class="{
          'active': [
            'Admin Conversations',
            'Admin Conversation Detail'
          ].includes($route.name)
        }"
      >
        <feather type="message-square" />
        <span>Conversations</span>
      </b-nav-item>
      <b-nav-item
        to="/admin/recent-activities"
        class="admin-left-sidebar--nav-item pl-5"
        :class="{
          'active': $route.path === '/admin/recent-activities'
        }"
      >
        <feather type="message-square" />
        <span>Recent Activities</span>
      </b-nav-item>
      <b-nav-item
        to="/admin/call-positions"
        class="admin-left-sidebar--nav-item pl-5"
        :class="{
          'active': [
            'Admin Call Positions',
            'Admin Create Call Position',
            'Admin Edit Call Position'
          ].includes($route.name)
        }"
      >
        <feather type="map-pin" />
        <span>Call Positions</span>
      </b-nav-item>
      <b-nav-item class="admin-left-sidebar--nav-item category-item px-4">
        Configuration
      </b-nav-item>
      <b-nav-item
        v-if="$permission('list:numbers')"
        to="/admin/numbers"
        class="admin-left-sidebar--nav-item pl-5"
        :class="{
          'active': [
            'Admin Numbers',
            'Admin Create Number',
            'Admin Edit Number'
          ].includes($route.name)
        }"
      >
        <feather type="hash" />
        <span>Provider Numbers</span>
      </b-nav-item>
      <b-nav-item
        v-if="$permission('list:templates')"
        to="/admin/templates"
        class="admin-left-sidebar--nav-item pl-5"
        :class="{
          'active': [
            'Admin Templates',
            'Admin Create Template',
            'Admin Edit Template'
          ].includes($route.name)
        }"
      >
        <feather type="file-text" />
        <span>Message Templates</span>
      </b-nav-item>
      <b-nav-item
        v-if="$permission('read:settings')"
        to="/admin/settings"
        class="admin-left-sidebar--nav-item pl-5"
        :class="{
          'active': $route.path === '/admin/settings'
        }"
      >
        <feather type="sliders" />
        <span>Settings</span>
      </b-nav-item>
      <b-nav-item
        v-if="$permission('list:users')"
        class="admin-left-sidebar--nav-item category-item px-4"
      >
        User Management
      </b-nav-item>
      <b-nav-item
        v-if="$permission('list:users')"
        to="/admin/users"
        class="admin-left-sidebar--nav-item pl-5"
        :class="{
          'active': [
            'Admin Create User',
            'Admin Users',
            'Admin Edit User'
          ].includes($route.name)
        }"
      >
        <feather type="users" />
        <span>Users</span>
      </b-nav-item>
      <b-nav-item
        v-if="$permission('list:users')"
        to="/admin/invitations"
        class="admin-left-sidebar--nav-item pl-5"
        :class="{
          'active': [
            'Admin User Invitations',
            'Admin User Invitation Detail'
          ].includes($route.name)
        }"
      >
        <feather type="user-plus" />
        <span>User Invitations</span>
      </b-nav-item>
      <b-nav-item
        v-if="$permission('list:users')"
        to="/admin/roles"
        class="admin-left-sidebar--nav-item pl-5"
        :class="{
          'active': [
            'Admin User Roles',
            'Admin Create User Role',
            'Admin Edit User Role'
          ].includes($route.name)
        }"
      >
        <feather type="user-check" />
        <span>User Roles</span>
      </b-nav-item>
    </b-nav>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AdminLeftSidebar",
  computed: {
    ...mapGetters("user", ["isDarkMode"]),
  },
};
</script>

<style lang="scss">
.admin-left-sidebar {
  width: 100%;
  height: 100%;
  &.dark {
    & .nav-item {
      > a {
        color: #b2b9bf;
      }
    }
  }

  &--nav {
    &-item {
      display: flex;
      align-items: center;
      height: 50px;
      opacity: 1;

      >a {
        display: inline-flex;
        align-items: center;
        padding: 0;
        font-size: 14px;
        color: #5b5d60;
        gap: 8px;
      }

      &.active .nav-link {
        color: #186dde !important;
        font-weight: 700;
      }

      &.category-item {
        height: 60px;
        opacity: 0.4;

        >a {
          font-size: 12px;
          font-weight: 500;
          text-transform: uppercase;
        }
      }
    }
  }
}
</style>